var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    stroke: "currentColor",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 2,
    d: "M26.469 1.985c-3.415 0-6.364 1.914-7.807 4.7-1.444-2.786-4.393-4.7-7.807-4.7-4.835 0-8.753 3.83-8.753 8.553 0 0.027 0.004 0.053 0.004 0.080-0.043 0.931-0.011 9.949 16.556 19.396 17.507-9.977 16.562-19.477 16.562-19.477 0-4.724-3.919-8.553-8.754-8.553z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.d4a450394b3469fe730788b8122ce964.svg";
export { ForwardRef as ReactComponent };